import { FC } from 'react';
import { DataTree } from '../../types';
import { useSearchStore } from '../../stores/search';

interface AccordionSectionProps {
  categoriesData: DataTree[];
}

export const MobileSelectMenu: FC<AccordionSectionProps> = (
  {
    categoriesData,
  }): JSX.Element => {
  const currentCategoryId = useSearchStore((state) => state.currentCategoryId)
  const setCurrentCategoryId = useSearchStore((state) => state.setCurrentCategoryId)
  const setAlphabetSearchCharacter = useSearchStore((state) => state.setAlphabetSearchCharacter);
  
  const setCurrentCategoryName = useSearchStore((state) => state.setCurrentCategoryName)
  const setSearchQueryInput = useSearchStore((state) => state.setSearchQueryInput)
  
  if (!categoriesData) {
    return <div>Loading...</div>;
  }
  
  const removeSearchQuery = (): void => {
    setSearchQueryInput('');
    setCurrentCategoryName('');
    setAlphabetSearchCharacter('');
  };
  
  return (
    <div className="">
      <select
        className={'rounded-xl w-full px-2 py-3'}
        onChange={(e) => {
          removeSearchQuery();
          setCurrentCategoryName(e.target.innerText);
          setCurrentCategoryId(e.target.value);
          setAlphabetSearchCharacter('')
        }}
        value={currentCategoryId}
        name="Categories"
      >
        <option selected disabled={true} value={''}> Търси по категория</option>
        {categoriesData.map((category, index) => (
          <option key={index} id={category.id} value={category.id}>
            {category.name}</option>
        ))}
      </select>
    </div>
  );
};
